import React from "react";
import "./spinner.scss";

export default function Spinner() {
  return (
    <div className="spinner lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}
